import { EditFieldTheme, FieldError, FieldStatus } from '@/framework/base/components/FieldInfo';
import Ressource from "@/framework/ressource/classes/Ressource";
import { MapRessource } from '@/framework/base/helpers/Ressources';
import { Fiches, Sections } from "@/generated/classes/AppSchema";
import Owner from '@/generated/classes/Owner';
import { ColumnFilter, ListFilter } from "@/extend/classes/ListData";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    components: {},
    props: {
        value: {
            type: Number,
            required: true
        },
        owner: {
            type: Object as PropType<Owner>,
            required: true
        },
        parentObj: {
            type: Object as PropType<unknown>
        },
        label: {
            type: String
        },
        readOnly: {
            type: Boolean
        },
        required: {
            type: Boolean
        },
        moduleId: {
            type: Number
        },
        excludeIds: {
            type: Array as PropType<number[]>
        },
        autoClear: {
            type: Boolean
        },
        contextId: {
            type: Number,
            required: true
        },
        hideLabel: {
            type: Boolean
        },
        dataTable: {
            type: Boolean
        },
        theme: {
            type: Object as PropType<EditFieldTheme>
        },
        ressource: {
            type: Object as PropType<Ressource>,
            required: true
        },
        newLabel: {
            type: String
        },
        selectText: {
            type: String
        },
        showMissing: {
            type: Boolean
        },
        ressourceHeader: {
            type: Object as PropType<MapRessource>
        },
        toggleReset: {
            type: Boolean
        },
        fiche: {
            type: String
        },
        sectionName: {
            type: String,
            required: true
        },
        filters: {
            type: Array as PropType<ColumnFilter[]>
        },
        autoSelect: {
            type: Boolean
        },
        requiredAttributs: {
            type: Array as PropType<string[]>
        }
    },
    created(): void {
        this.initValue = this.value ? this.value : 0;
        this.status.objId = this.contextId
    },
    data() {
        const cancelChanges = undefined as undefined | boolean;

        return {
            initValue: 0,
            status: new FieldStatus(false, false, 0),
            dialogOpen: false,
            lastContextId: 0,
            cancelChanges,
            lastToggle: false,
            filterCondition: "",
            sort: "",
            notOrdered: false
        };
    },
    computed: {
        clearAuto(): boolean {
            return this.autoClear == undefined || this.autoClear == true;
        },
        filter(): ListFilter | null {
            if (this.filters == null && typeof this.filters !== 'undefined') {
                return null;
            } else {
                const filter = new ListFilter();
                if (this.filters && this.filters.length > 0) {
                    this.resetNotOrdered(true);
                    filter.columnsFilter = this.filters;
                }
                return filter;
            }
        }
    },

    methods: {
        resetNotOrdered(value: boolean) {
            this.notOrdered = value;
        },
        changeContext(): void {
            if (this.lastContextId != this.contextId) {
                this.lastContextId = this.contextId;
                this.status.objId = this.contextId;
                this.contextChanged();
            }
        },
        resetToggle(): boolean {
            if (this.lastToggle != this.toggleReset) {
                this.lastToggle = this.toggleReset;
                return true && this.initValue != this.value;
            } else {
                return false;
            }
        },
        contextChanged(): void {
            // To implement
        },
        save(): void {
            this.initValue = this.value;
            this.status.clear(this.contextId);
            this.$emit('status', this.status);
        },
        closeDialog() {
            this.dialogOpen = false;
        },
        onEdit() {
            this.dialogOpen = true
            this.cancelChanges = false
        },
        setError(value: FieldError): void {
            this.status.error = value.error;
            this.$emit('status', this.status);
        }
    }
})
